import { userLogOut } from "./currentUserSlice";
import { Tracker, Tracker2 } from "../components/utils/mixpanel/tracker";

export const userLogOutWithTracking = () => (dispatch) => {
  dispatch(userLogOut());
  Tracker.reset();
  Tracker2.reset();
};
